import PackageSummary from './PackageSummary';

export default PackageSummary;
